import styles from './RemovalHero.module.css';

function scrollToForm() {
  document.getElementById('removal-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function RemovalHero() {
  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>Privacy</span>
        <h1 className={styles.headline}>Request removal/deletion from RepBuddy</h1>
        <p className={styles.subtitle}>Opt-out of sale and sharing</p>

        <p className={styles.body}>
          If you would like RepBuddy to remove your individual profile from our database,
          please use the Request Removal link below. Once processed, your profile will no
          longer be available in our products. We may retain limited information as needed to
          process and honor your request, comply with legal obligations, maintain a record of
          your request, and help prevent your information from being re-added.
        </p>

        <button className={styles.cta} onClick={scrollToForm}>Request removal</button>
      </div>
    </section>
  );
}
